export default __webpack_public_path__ + "static/media/tab-connect-participants.84c84283.png";